type FieldValue = string | number | boolean | null | undefined;
type FormPayload = URLSearchParams | FormData | HTMLFormElement | Record<string, FieldValue>;

const FORM_EMAIL = import.meta.env.VITE_CHURCH_FORM_EMAIL || 'contact@smpcvi.ca';
const STORAGE_KEY = 'smpcvi_website_form_submissions';

function collectFields(payload: FormPayload): Record<string, string> {
  if (payload instanceof HTMLFormElement) {
    return collectFields(new FormData(payload));
  }

  const fields: Record<string, string> = {};

  if (payload instanceof URLSearchParams) {
    payload.forEach((value, key) => {
      fields[key] = value;
    });
    return fields;
  }

  if (payload instanceof FormData) {
    payload.forEach((value, key) => {
      fields[key] = value instanceof File ? value.name : String(value);
    });
    return fields;
  }

  Object.entries(payload).forEach(([key, value]) => {
    fields[key] = value == null ? '' : String(value);
  });

  return fields;
}

function saveSubmission(formName: string, fields: Record<string, string>) {
  const submission = {
    formName,
    fields,
    submittedAt: new Date().toISOString(),
  };

  const existing = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
  existing.push(submission);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
}

function openEmailDraft(formName: string, fields: Record<string, string>) {
  const lines = Object.entries(fields)
    .filter(([, value]) => value.trim() !== '')
    .map(([key, value]) => `${key}: ${value}`);

  const subject = encodeURIComponent(`Website form: ${formName}`);
  const body = encodeURIComponent([
    `A ${formName} submission was started from the website.`,
    '',
    ...lines,
  ].join('\n'));

  window.location.href = `mailto:${FORM_EMAIL}?subject=${subject}&body=${body}`;
}

export async function submitLocalForm(formName: string, payload: FormPayload) {
  const fields = collectFields(payload);
  saveSubmission(formName, fields);
  openEmailDraft(formName, fields);
  return { ok: true };
}
